import "./App.css";
import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Home from "./components/home";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/css/style.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from "./components/header";
import Footer from "./components/footer";
import University from "./components/Universities";
import Recruiter from "./components/Recruiters";
import Aggregators from "./components/Aggregators";
import HowItWorks from "./components/Company/HowItWorks";
import Blog from "./components/Company/Blog";
import About from "./components/Company/about";
import Careers from "./components/Company/Careers";
import Contact from "./components/Contact";
import CookiePolicy from "./components/Cookies";
import Privacy from "./components/Privacy";
import Payment from "./components/Payment";

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />  {/* Common Navbar */}
        <Routes>
          <Route path="/" element={<Home />} />
           <Route path="/universities" element={<University />} />
           <Route path="/recruiters" element={<Recruiter />} />
            <Route path="/aggregators" element={<Aggregators />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
             <Route path="/blog" element={<Blog />} />
             <Route path="/about" element={<About />} />
             <Route path="/career" element={<Careers />} />
             <Route path="/contact" element={<Contact />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
               <Route path="/privacy-policy" element={<Privacy />} />
                <Route path="/payment-terms" element={<Payment />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
